function assets(backendAxiosInstance) {
  async function getAssetDetail(assetId) {
    return backendAxiosInstance.get(`/contents/v1/assets/${assetId}`, { includeLanguage: true });
  }
  async function searchAssets(searchAssetsParams) {
    return backendAxiosInstance.get(
      "/contents/v1/assets/search",
      {
        params: searchAssetsParams,
        includeClientType: true,
        includeTimeZone: true
      }
    );
  }
  return {
    getAssetDetail,
    searchAssets
  };
}

export { assets as default };
//# sourceMappingURL=asset.js.map
